export default __webpack_public_path__ + "static/media/node.ed5c8001.png";